module.exports = __webpack_public_path__ + "assets/img/warrior-name-7f995fd2.png";